<template>
  <section class="m_section">
    <Inquiry v-if="isAuth === false && inquiry" :agreePrivacy="agreePrivacy"/>
    <InquiryMember v-if="isAuth === true && inquiry" :agreePrivacy="agreePrivacy"/>
    <div class="contents" v-if="inquiry === false">
      <MobileGnb />
      <div class="tabcont_wrap without_tab inquiry_login">
        <h2 class="title with_desc">상담하기</h2>
        <br/>
        <h2 class="title with_desc" style="text-align: left;">개인정보 수집 &middot; 이용 동의</h2>
        <!-- <br/> -->
        <div class="sendNumberRegTable">
          <div class="inline-box">
            <p>LG유플러스는 U+메시지허브이지 서비스를 제공하기 위해 아래와 같이 개인 정보를 수집 및 이용합니다.</p>
            <p>LG유플러스는 최초 회원가입 시 서비스 제공을 원활하게 하기 위해 필요한 최소한의 정보를 수집하고 있으며, 회사가 제공하는 서비스 이용에 따른 결제 및 환불, 서비스 이행 등에 필요한 정보를 추가로 수집할 수 있습니다.</p>
            <br/>
            <table>
              <thead>
                <tr>
                  <th>수집항목</th>
                  <th>이용목적</th>
                  <th>보유 및 이용 기간</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>상담정보 <br/>(이름, 이메일 주소, 휴대폰 번호, 부서명)</td>
                  <td>상담 서비스 관련 편의 제공 및 불편사항 <br/> 개선, 상담 서비스 품질 향상을 위한 분석</td>
                  <td><span style="color:deepskyblue">상담일로부터 3년</span><br/>(전자상거래법 시행령 의거)</td>
                </tr>
              </tbody>
            </table>
            <p>※ 개인정보 수집&middot;이용 동의는 거부할 수 있습니다. 다만, 동의 거부시에는 서비스 이용이 제한될 수 있습니다.</p>
          </div>
        </div>
        <div class="chkbox">
          <input type="checkbox" class="chk" id="privacy" v-model="agreePrivacy" />
          <label for="privacy"><span style="color: deepskyblue;">[필수]</span>개인정보 수집 및 이용에 동의합니다.</label>
        </div>
        <div class="btn_wrap" v-if="isAuth === false">
          <a class="btn large_pink" @click="fnInquiry">비회원으로 상담하기</a>
          <router-link to="/login" class="btn large_white">로그인</router-link>
        </div>
        <div class="btn_wrap" v-else>
          <a class="btn large_pink" @click="fnInquiryMember">상담하기</a>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import confirm from "@/modules/commonUtil/service/confirm";
import Inquiry from "../components/Inquiry.vue";
import InquiryMember from "../components/InquiryMember.vue";
import MobileGnb from "@/components/MobileGnb.vue";

export default {
  name: "defaultName",
  components: { Inquiry, InquiryMember, MobileGnb },
  mounted() {
    this.isAuth = this.$store.getters["login/isAuth"];
  },
  data() {
    return {
      isAuth: false,
      inquiry: false,
      agreePrivacy:false
    };
  },
  methods: {
    //비회원 상담하기
    fnInquiry() {
      if(this.agreePrivacy){
        this.inquiry = true;
      }else{
        confirm.fnAlert("", "개인정보 수집 및 이용 동의가<br />있어야 비회원 상담이 가능합니다.", "alert");
        return false;
      }
    }, 
    fnInquiryMember() {
      if(this.agreePrivacy){
        this.inquiry = true;
      }else{
        confirm.fnAlert("", "개인정보 수집 및 이용 동의가<br />있어야 상담이 가능합니다.", "alert");
        return false;
      }
    }
  },
};
</script>
